import React from "react";
import CustomTooltip from "app/components/Tooltip";
import Pill from "app/components/Pill";
import { ITags } from "app/containers/Features/components/CommonTagSelection/types";

interface SelectedTagsPreviewProps {
  tags: ITags[];
  visibleCount?: number;
}

const SelectedTagsPreview: React.FC<SelectedTagsPreviewProps> = ({
  tags,
  visibleCount = 3,
}) => {
  if (!tags.length) return <span className=" text-secondary ">-</span>;

  const visibleTags = tags.slice(0, visibleCount);
  const remainingCount = tags.length - visibleCount;

  const renderTag = ({ _id, color, title }: ITags) => (
    <Pill
      key={_id}
      backgroundColor={color}
      name={title}
      className="min-w-0 max-w-full px-[6px] py-[2px] text-[10px] leading-[18px] font-medium text-black"
    />
  );

  return (
    <div className="flex min-w-0 max-w-full justify-end gap-1 overflow-hidden">
      {visibleTags.map(renderTag)}

      {remainingCount > 0 && (
        <CustomTooltip
          text={
            <div className="flex flex-wrap gap-1 max-w-[240px]">
              {tags.map(renderTag)}
            </div>
          }
          isWhiteBg
          position="bottom"
          className="flex items-center"
          contentClassName="break-words"
        >
          <div className="size-[18px] flex items-center justify-center rounded-full bg-[#999FA7] text-white text-[10px] font-medium">
            +{remainingCount}
          </div>
        </CustomTooltip>
      )}
    </div>
  );
};

export default SelectedTagsPreview;
